export default {
  "dailyRebateAdmin.thead.index": "#NO",
  "dailyRebateAdmin.thead.gameType": "GameType",
  "dailyRebateAdmin.thead.providerId": "ProviderId",
  "dailyRebateAdmin.thead.rebateConfig": "RebateConfig",
  "dailyRebateAdmin.thead.createdAt": "CreatedAt",
  "dailyRebateAdmin.thead.updatedAt": "UpdatedAt",
  "dailyRebateAdmin.thead.status": "Status",

  "dailyRebateAdmin.add": "Add",
  "dailyRebateAdmin.edit": "Edit",
  "dailyRebateAdmin.details": "Details",
  "dailyRebateAdmin.delete": "Delete",
  "dailyRebateAdmin.showConfig": "ShowConfig",

  "dailyRebateAdmin.thead.action": "Action",
};
